// CNAE service using listacnae.com.br API
// Docs: https://listacnae.com.br/docApi

const BASE = "https://listacnae.com.br/api";

// CNAE service using IBGE API
// Docs: https://servicodados.ibge.gov.br/api/docs/cnae

const IBGE_BASE = "https://servicodados.ibge.gov.br/api/v2/cnae/subclasses";
let CNAE_CACHE = null;

export async function fetchAllCnaes() {
  if (CNAE_CACHE) return CNAE_CACHE;
  const res = await fetch(IBGE_BASE);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  // IBGE returns array of { id, descricao }
  CNAE_CACHE = data.map((it) => ({
    code: it.id,
    description: it.descricao,
  }));
  return CNAE_CACHE;
}

export async function searchCnae(query = "", page = 1, perPage = 10) {
  try {
    const all = await fetchAllCnaes();
    const normalizedQuery = (query || "").trim().toLowerCase();
    const filtered = normalizedQuery
      ? all.filter(
          (it) =>
            it.code.toLowerCase().includes(normalizedQuery) ||
            it.description.toLowerCase().includes(normalizedQuery)
        )
      : all;

    const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
    const currentPage = Math.min(Math.max(1, page), totalPages);
    const start = (currentPage - 1) * perPage;
    const items = filtered.slice(start, start + perPage);

    return { page: currentPage, totalPages, items };
  } catch (err) {
    return { page: 1, totalPages: 1, items: [] };
  }
}

export async function getCnaePage(page = 1, perPage = 10) {
  return searchCnae("", page, perPage);
}

export async function verifyCNAE(cnae) {
  const treatedCNAE = formatCNAEList([cnae])[0];
  const url = IBGE_BASE + "/" + treatedCNAE;
  const res = await fetch(url);
  if (!res.ok) return false;
  const data = await res.json();
  return !!data.id;
}

export async function verifyManyCNAEs(list) {
  let allAreValid = true;
  for (const cnae of list) {
    const thisIsValid = await verifyCNAE(cnae);
    allAreValid = allAreValid && thisIsValid;
  }
  return allAreValid;
}

export function formatCNAEList(list) {
  return list.map((cnae) => String(cnae).replace(/\D/g, ""));
}
